import React from 'react';

import { AviationColorCode } from '@vona/shared';

import { createStyles } from '../tss';

const useStyles = createStyles(() => ({
  root: {
    borderRadius: '50%',
    display: 'inline-block',
    height: 16,
    width: 16,
  },
  green: {
    backgroundColor: '#6e9f04',
  },
  yellow: {
    backgroundColor: '#e9cb2b',
  },
  orange: {
    backgroundColor: '#ff7122',
  },
  red: {
    backgroundColor: '#d94933',
  },
  unassigned: {
    backgroundColor: '#808080',
  },
  nil: {
    backgroundColor: '#808080',
  },
}));

type Props = {
  colorCode: AviationColorCode;
  'data-testid'?: string;
};

export const ColorCodeOrb: React.FC<Props> = ({ colorCode, 'data-testid': dataTestId }) => {
  const { classes, cx } = useStyles();
  const className = cx(classes.root, {
    [classes.green]: colorCode === 'GREEN',
    [classes.yellow]: colorCode === 'YELLOW',
    [classes.orange]: colorCode === 'ORANGE',
    [classes.red]: colorCode === 'RED',
    [classes.unassigned]: colorCode === 'UNASSIGNED',
    [classes.nil]: colorCode === 'NIL',
  });
  return (
    <div className={className} data-testid={dataTestId} data-colorcode={colorCode} />
  );
};
